<app-header>
  <h1 app-overline>Step 1</h1>
  <h2 app-title>Verify your pattern configuration</h2>
</app-header>

<ng-container *ngIf="pattern">
  <app-card-pattern-config [pattern]="pattern"></app-card-pattern-config>
</ng-container>
